import React from 'react';
import DropZoneContainer from './DropZoneContainer';

export default function withDropzone(WrappedComponent) {
  return props => (
    <DropZoneContainer>
      <WrappedComponent {...props} />
    </DropZoneContainer>
  );
}
